<div style="max-height: 90vh !important" class="card card-custom d-flex flex-column">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'DOCS_MODULE.DOCUMENT.SHARE_DOCUMENT' | translate }}</h3>
    </div>
  </div>
  <div
    style="max-height: unset !important"
    class="card-body flex-grow-1 scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <form [formGroup]="form" class="form form-group mb-0">
      <div class="w-100 mb-4">
        <kt-general-autocomplete
          #documentAutocomplete
          [label]="'DOCS_MODULE.DOCUMENT.DOCUMENT' | translate"
          [appearance]="'fill'"
          [dataPath]="'data'"
          [control]="documentAutocomplete"
          [loadItemsFunction]="getDocumentAutocomplete"
          [change]="handleChange.bind(this)"
          [optionFormatter]="formatDocumentOption"
          [valueFormatter]="formatDocumentValue.bind(this)"
          [readOnly]="!!data.document?.id"
          [required]="true"
        ></kt-general-autocomplete>
      </div>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'DOCS_MODULE.DOCUMENT.METHODS' | translate }}</mat-label>
        <mat-select formControlName="methods" multiple required (selectionChange)="handleChange()">
          <mat-option *ngFor="let m of sharingMethods" [value]="m">{{
            stringUtils.formatEnumString(m)
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('methods')">{{
          getErrorMessage('DOCS_MODULE.DOCUMENT.METHODS' | translate)
        }}</mat-error>
      </mat-form-field>
      <div class="w-100 mb-4">
        <kt-general-autocomplete
          #receiverAutocomplete
          [label]="'DOCS_MODULE.DOCUMENT.TO' | translate"
          [appearance]="'fill'"
          [chipList]="true"
          [dataPath]="'data'"
          [control]="receiverAutocomplete"
          [objects]="receiverAutocomplete.value"
          [loadItemsFunction]="getReceiverAutocomplete"
          [optionFormatter]="formatReceiverOption"
          [valueFormatter]="formatReceiverOption"
          [formatNewObjectFn]="formatNewReceiver"
          [readOnly]="!documentAutocomplete?.value?.id"
          [required]="true"
        ></kt-general-autocomplete>
      </div>
      <quill-editor formControlName="body" [modules]="quillModules"></quill-editor>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SEND' | translate }}
    </button>
  </div>
</div>
